import { render, staticRenderFns } from "./AlternatePANActivity.vue?vue&type=template&id=f1ff76e8&scoped=true&"
import script from "./AlternatePANActivity.vue?vue&type=script&lang=js&"
export * from "./AlternatePANActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=f1ff76e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ff76e8",
  null
  
)

export default component.exports